// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__container--SeOi5{display:flex;justify-content:flex-start;align-items:flex-start;font-size:15px}.index-module__message-log-icon--shel3{position:relative}.index-module__info-container--zww90{display:flex;flex-direction:column;margin-left:10px}.index-module__title--Tx584{display:flex;align-items:flex-start;line-height:14px}.index-module__message-status--bFqlp{display:flex;flex-direction:column;text-transform:capitalize;line-height:16px;color:#373e44}.index-module__message-status--bFqlp .index-module__published--t1Oh9{margin-left:8px}.index-module__reason--pZsHB{font-style:italic;text-transform:capitalize;font-size:13px}.index-module__date--pskJg{margin-top:3px;font-size:11px;line-height:18px}.index-module__green--Bc4Wf{color:#35b840;fill:#35b840}.index-module__red--lv0vT{color:#db3737;fill:#db3737}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `index-module__container--SeOi5`,
	"message-log-icon": `index-module__message-log-icon--shel3`,
	"messageLogIcon": `index-module__message-log-icon--shel3`,
	"info-container": `index-module__info-container--zww90`,
	"infoContainer": `index-module__info-container--zww90`,
	"title": `index-module__title--Tx584`,
	"message-status": `index-module__message-status--bFqlp`,
	"messageStatus": `index-module__message-status--bFqlp`,
	"published": `index-module__published--t1Oh9`,
	"reason": `index-module__reason--pZsHB`,
	"date": `index-module__date--pskJg`,
	"green": `index-module__green--Bc4Wf`,
	"red": `index-module__red--lv0vT`
};
export default ___CSS_LOADER_EXPORT___;
